import React, { FC } from 'react'
import { ModuleNames } from '../../../../constants/componentNames.constants'
import { DownArrow, DownCarat } from '../../../../constants/svg'
import { MenuGroup } from '../../../../models/others/menuGroup'
import { arraysMatch } from '../../../../utils/functions.utils'
import {
  createLinkBasedOnType,
  createTextBasedOnType,
  isExternalURL,
} from '../../../../utils/link.utils'
import Typography from '../../../global/typography'
import { BlogNavLinkTitle, InnerDrawer, NavDropdownItem } from './style'

type Props = {
  blogNav: any
  pagePath: string
  isNonNavigationPage: boolean
  secondaryDrawerOpen: any
  handleSecondaryDrawerClick: any
}

export const BlogNavLinks: FC<Props> = ({
  blogNav,
  pagePath,
  isNonNavigationPage,
  secondaryDrawerOpen,
  handleSecondaryDrawerClick,
}) => {
  return (
    <div className="BlogNav__Inner-Links">
      {blogNav.menuGroups.map((menuGroup: MenuGroup, i: number) => {
        if (menuGroup.__typename === ModuleNames.MENU_GROUP) {
          return (
            <NavDropdownItem
              key={`BlogNavDropdown--${i}`}
              className="BlogNav__Dropdown"
              $secondaryDrawerOpen={secondaryDrawerOpen}>
              <div className="BlogNavDropdown__Arrow-Title" onClick={handleSecondaryDrawerClick}>
                <BlogNavLinkTitle type="label" className="BlogNavDropdown__Title">
                  {menuGroup.newGroupName}
                </BlogNavLinkTitle>
                <DownCarat />
                <DownArrow />
              </div>

              <InnerDrawer
                className="BlogNavDropdown__Links"
                $secondaryDrawerOpen={secondaryDrawerOpen}>
                {menuGroup.pages?.map((page: any, j: number) => {
                  const linkHref = createLinkBasedOnType(page)
                  const linkTitle = createTextBasedOnType(page)
                  const target = isExternalURL(linkHref) ? '_blank' : '_self'

                  return (
                    <a
                      key={linkTitle}
                      className="BlogNavDropdown__Inner-Item"
                      href={linkHref}
                      rel="noopener"
                      target={target}>
                      <Typography
                        type="bodyXS"
                        className="BlogNavDropdown__Inner-Item-Title font__inter">
                        {linkTitle}
                      </Typography>
                    </a>
                  )
                })}
              </InnerDrawer>
            </NavDropdownItem>
          )
        } else if (menuGroup.__typename === ModuleNames.TOPIC_CTA) {
          const linkHref = createLinkBasedOnType(menuGroup)
          const linkTitle = createTextBasedOnType(menuGroup)
          const target = isExternalURL(linkHref) ? '_blank' : '_self'

          const blogRegex = /\/blog[^0-9]*/g
          let pagePathMatch, linkMatch
          let isActiveLink = false

          if (pagePath) {
            pagePathMatch = pagePath.match(blogRegex)

            if (pagePathMatch && pagePathMatch[0][pagePathMatch[0].length - 1] === '/') {
              pagePathMatch[0] = pagePathMatch[0].slice(0, -1)
            }
          }

          if (linkHref) {
            linkMatch = linkHref.match(blogRegex)
          }

          if (linkMatch && linkMatch[0] && pagePathMatch && pagePathMatch[0]) {
            if (typeof pagePathMatch[0] === 'string' && typeof linkMatch[0] === 'string') {
              if (!isNonNavigationPage) {
                let splitPagePath = pagePathMatch[0].split('/')
                const splitLink = linkMatch[0].split('/')

                if (splitPagePath.length === 4) {
                  splitPagePath.pop()
                }

                const linksMatch = arraysMatch(splitPagePath, splitLink)
                if (linksMatch) {
                  isActiveLink = true
                }
              } else if (isNonNavigationPage && linkMatch[0] === '/blog') {
                //* Make blog tab active for author pages
                isActiveLink = true
              }
            }
          }

          return (
            <BlogNavLinkTitle
              type="label"
              key={`BlogNav__CTA--${i}`}
              className={isActiveLink ? `BlogNav__CTA--Active` : `BlogNav__CTA--Inactive`}>
              <a href={linkHref} className="NavDropdownItem__Link" rel="noopener" target={target}>
                {linkTitle}
              </a>
            </BlogNavLinkTitle>
          )
        }
      })}
    </div>
  )
}
